var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a-modal', {
    attrs: {
      "width": 500,
      "maskClosable": false,
      "keyboard": false,
      "visible": _vm.visible
    },
    on: {
      "cancel": function cancel($event) {
        _vm.visible = false;
      }
    }
  }, [_c('h2', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("温馨告知")]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.handleOk(true);
      }
    }
  }, [_vm._v("我已阅读并申请陪同")]), _c('a-divider', {
    attrs: {
      "type": "vertical"
    }
  }), _c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.handleOk(false);
      }
    }
  }, [_vm._v("不需要")])], 1), _c('div', [_c('p', [_vm._v("为保障年龄偏小的学生顺利完成在线测评，将允许学生在监护人陪同下进行测评。")]), _c('p', [_vm._v("您若点击“我已阅读并申请陪同”按钮后，系统将视为您认同以下内容：")]), _c('br'), _c('p', [_vm._v("一、遵守监考纪律：")]), _c('p', [_vm._v("1、全程保持开启视频和音频录制、录屏等监考手段；")]), _c('p', [_vm._v("2、禁止参与测评题目相关的任何形式的提示或代操作；")]), _c('p', [_vm._v("3、对测评内容进行保密，不拍照不截屏不传播。")]), _c('br'), _c('p', [_vm._v("二、履行陪同义务：")]), _c('p', [_vm._v("1、有能力协助学生调试监考视频和屏幕分享、解决电脑软硬件故障；")]), _c('p', [_vm._v("2、必要时，协助学生检查文件是否保存成功等。")]), _c('br'), _c('p', [_vm._v("作为监护人承诺，若不能履行义务则自动退出陪同。若违反监考纪律，同意将学生成绩按无效处理。")]), _c('br'), _c('p', [_vm._v("学生若无需陪同，可点击“不需要”后，进入测评。")])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };